<template>
  <div>
    <div class="row mt-1 ml-0">
      <a class="btn-link smaller" href="#"
            @click="addAffiliate">
        <i class="fa fa-plus"></i> Add Affiliate
      </a>
    </div>
    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="rowClick"
              id="affiliatesTable" class="table-striped" 
              :data="data" :row-class-name="rowClasses">
      <!-- <el-table-column type="index">

      </el-table-column> -->
      <el-table-column v-if="!hideCompany" label="Company">
        <template slot-scope="{row}">
          <template v-if="row">
            {{ $store.getters.getIncentifyerName(row.companyId) }}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="Affiliate">
        <template slot-scope="{row}">
          <template v-if="row">
            {{row.firstName + ' ' + row.lastName}}
          </template>
        </template>
      </el-table-column>
      <el-table-column v-if="!hidePosition" prop="position" label="Position"/>
      <el-table-column width="90" v-if="!(hidePayouts||hideLeads)" label="Payouts">
        <template slot-scope="{row}">
          <template v-if="row">
            <span style="font-size: 125%">
              {{ $store.getters.currency + $store.getters.getPayoutsForAffiliate(row.id).total }}
            </span>
            <a class="btn-info text-primary btn-link d-none showOnHover mr-1" v-tooltip.top-center="'Give Payout'"
              @click="addPayout(row.id)">
              <i class="fad fa-money-check-edit-alt"></i>
            </a>
          </template>
        </template>
      </el-table-column>
      <el-table-column width="70" v-if="!(hideLeadsReceived||hideLeads)" label="Leads">
        <template slot-scope="{row}">
          <span style="font-size: 125%;">
            {{ $store.getters.affiliatesLeads[row.id].total }}
          </span>
          <a class="btn-success btn-link d-none showOnHover mr-1" v-tooltip.top-center="'Add Lead'"
            @click="addLead(row.id)">
            <i class="fad fa-inbox-in"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column width="67" v-if="!(hideLeadsClosed||hideLeads)" label="Closed">
        <template slot-scope="{row}">
          <span style="font-size: 125%;">
            {{ $store.getters.affiliatesLeads[row.id].closed }}
          </span>
          <a class="btn-success btn-link d-none showOnHover mr-1" v-tooltip.top-center="'Close Lead'"
            @click="closeLead(row.id)">
            <i class="fad fa-box-check"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column :width="(hideLeads||hideLeadsClosed)?'75':'55'" v-if="!hideCloseRate"
                      :label="(hideLeads||hideLeadsClosed)?'Close Rate':'Rate'">
        <span style="font-size: 100%;" slot-scope="{row}">
          <template v-if="$store.getters.affiliatesLeads[row.id].closeRate">
            {{ $store.getters.affiliatesLeads[row.id].closeRate }}%
          </template>
        </span>
      </el-table-column>
      <el-table-column width="30">
        <template slot-scope="{row}">
          <!-- <a class="btn-info btn-link mr-1 ml-3" v-tooltip.top-center="'Edit'" @click="editAffiliate">
            <i class="fa fa-edit"></i>
          </a>
          <a v-if="!row.deletable" class="btn-neutral btn-link mr-1" :style="{cursor: 'pointer'}"
              
              v-tooltip.top-center="row.archived?'Unarchive':'Archive'">
            <i class="fas" :class="{'fa-archive': !row.archived, 'fa-reply': row.archived}"></i>
          </a> -->
          <a v-if="row.deletable" class="btn-danger btn-link" v-tooltip.top-center="'Delete'"
                                  @click="removeAffiliate(row.id, $event)">
            <i :class="'fa fa-times'+' aff'+row.id"></i>
          </a>
        </template>
      </el-table-column>

      <el-table-column width="1">
        <template slot-scope="{row}">
          <div :affiliateid="row.id"/>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import {Affiliate, AffiliateCompany, Payout, Lead} from 'src/classes/datamodel.js'
export default {
    name: 'Affiliates-Table',
    props: {
      hidePosition:       {type: Boolean, default: false},
      hideCompany:        {type: Boolean, default: false},
      hideLeadsReceived:  {type: Boolean, default: false},
      hideLeadsClosed:    {type: Boolean, default: false},
      hideLeads:          {type: Boolean, default: false},
      hidePayouts:        {type: Boolean, default: false},
      hideCloseRate:      {type: Boolean, default: false},
      forCompany:         {type: Object, default: null}
    },
    computed: {
      data () {
        //console.log('data(): ', this.$store.getters.affiliates)
        return (this.forCompany && this.forCompany.id) ? this.$store.getters.affiliates.filter(aff => aff.companyId == this.forCompany.id)
                                                     : this.$store.getters.affiliates
      }
    },
    methods: {
      addAffiliate () {
        var companyId = null
        var path = this.$route.path
        switch (true) {
          case (path.includes('/home')):
            companyId = this.$store.getters.companySelected
            break
          case (path.includes('/setup')):
            companyId = this.forCompany.id
            break
          default:
            break
        }

        this.$store.dispatch('openModal', {name: 'Affiliate', mode: 'Create',
                                           object: new Affiliate(companyId?{companyId}:{})})
      },
      editAffiliate (row) {
        //console.log('setupDate = ', this.$store.state.)
        console.log('editAffiliate(): ', row)
        this.$store.dispatch('openModal', {name: 'Affiliate', mode: 'Edit',
                                           object: new Affiliate(row)} )
      },
      async removeAffiliate (affiliateId, event) {
        var affiliate
        console.log('removeAffiliate(): ', affiliateId)
        if (!event) { // = coming from Affiliate modal
          this.dialogVisibleAffiliate = false
          affiliate = this.selectedAffiliate
        } else { // = coming from the table itself
          affiliate = this.$store.getters.affiliates.find(elem => elem.id == affiliateId)
        }
        const res = await this.$store.dispatch('deleteRestObject', affiliate)
        if (res.errors) {
          if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else { this.$notify({ successMessage: 'Saved!'})
        }
      },
      addPayout (affiliateId) {
        this.$store.dispatch('openModal', {name: 'Payout', mode: 'Create',
                                           object: new Payout({affiliateId})})
      },
      addLead (affiliateId) {
        this.$store.dispatch('openModal', {name: 'Lead', mode: 'Create',
                                           object: new Lead({affiliateId, status: Lead._status.RECEIVED.value})})
      },
      closeLead (affiliateId) {
        this.$store.dispatch('openModal', {name: 'Lead', mode: 'Close',
                                           object: new Lead({affiliateId, status: Lead._status.CLOSED.value})})
      },
      rowClasses ({row, rowIndex}) {
        return row.archived?'archivedTableRow clickableRow':'clickableRow'
      },
      rowHover(row, column, cell, event) {
        // We show all buttons of class .showOnHover
        var rows = $('#affiliatesTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var foundRow = JSON.stringify($(rows[i]).html().indexOf('affiliateid="'+row.id+'"')) > -1
          var archivedRow = $(rows[i]).attr('class').indexOf('archivedTableRow') > -1
          if (foundRow && !archivedRow) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).removeClass('d-none')
            }
            break
          }
        }
      },
      rowHoverLeave (row, column, cell, event) {
        // We hide all buttons of class .showOnHover
        var rows = $('#affiliatesTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var index = JSON.stringify($(rows[i]).html().indexOf('affiliateid="'+row.id+'"'))
          if (index > -1) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).addClass('d-none')
            }
            break
          }
        }
      },
      rowClick (row, column, event) {
        // We check to see if the click happened on an icon button
        // var match = JSON.stringify(event.toElement.classList.value).match(/fa[rsdl]{0,1}\sfa-/i)
        var path = event.path || event.composedPath() // 2nd one if for Firefox
        var match = JSON.stringify(path[0].className).match(/fa[rsdl]{0,1}\sfa-/i)
        if (match && match.index > -1) {
          // icon button, we ignore row click
        } else {
          //console.log('row click')
          this.editAffiliate(row)
        }
      }
    }
}
</script>

<style>
.el-table__row .cell {
  padding: 0;
}
.has-gutter .is-leaf .cell {
  padding: 0;
}
</style>